import { Category } from '@project-gd-x/dating-site-contracts/src/gen/gdx/core/writer/v1/writer_pb';
import { ref } from 'vue';

import { listIceBreakers } from '@/services/api/chat/chat-api';

export function useStoreChatIcebreakers(userId: string, categoryList: Category[] = []) {
  const icebreakerList = ref<string[]>([]);

  function loadIcebreakers() {
    return listIceBreakers(userId, categoryList).then((res) => {
      icebreakerList.value.push(...res.iceBreakers);
      return icebreakerList.value;
    });
  }

  return {
    icebreakerList,
    loadIcebreakers,
  };
}
